module.exports = __webpack_public_path__ + "img/20200402113545TIM截图20200402112556.13d1c8a6.png";